// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import apiRequest from '@src/utility/BackendRequest'

export const fetchEvents = createAsyncThunk('appCalendar/fetchEvents', async (options, { getState }) => {
  const params = { calendar: options.calendars, populate:'calendar, users, createdBy', limit:2000, sortBy:'-createdAt' }
  if (getState().calendar.selectedRange) {
    params.start = getState().calendar.selectedRange.getTime()
  }

  if (getState().calendar.selectedCase && getState().calendar.filterCase) {
    params.case = getState().calendar.selectedCase
  }

  if (options.calendars) {
    params.calendar = options.calendars.map((j) => {
      const result = getState().calendar.availableCalendars.find(i => i.name === j)
      return result.id
    })
  }

  // Add method filter (modalidad de contacto)
  const selectedModalidades = options.modalidades ?? getState().calendar.selectedModalidades
  if (selectedModalidades && selectedModalidades.length > 0) {
    params.method = selectedModalidades
  }

  // Add location filter (ubicación/sede)
  const selectedLocations = options.locations ?? getState().calendar.selectedLocations
  if (selectedLocations && selectedLocations.length > 0) {
    params.location = selectedLocations
  }

  const response = await apiRequest.get('/events', {params})
  return response.data.results
})

export const addEvent = createAsyncThunk('appCalendar/addEvent', async (event, { dispatch, getState }) => {
  event = {
    title: event.title,
    case: event.case,
    start: event.start,
    end: event.end,
    users: event.extendedProps.guests,
    calendar: event.extendedProps.calendar,
    notes: event.extendedProps.description,
    location: event.extendedProps.location,
    method: event.extendedProps.method,
    motive: event.extendedProps.motive,
    delito: event.extendedProps.delito,
    audiencia: event.extendedProps.audiencia,
    liga: event.extendedProps.liga,
    cj: event.extendedProps.cj,
    resolucion: event.extendedProps.resolucion,
    allDay: event.allDay
  }

  await apiRequest.post('/events', event)
  await dispatch(fetchEvents(getState().calendar.selectedCalendars))
  return event
})

export const updateEvent = createAsyncThunk('appCalendar/updateEvent', async (event, { dispatch, getState }) => {
  const id = event.id
  event = {
    title: event.title,
    start: event.start,
    end: event.end,
    users: event.extendedProps.guests,
    calendar: event.extendedProps.calendar,
    notes: event.extendedProps.description,
    location: event.extendedProps.location,
    method: event.extendedProps.method,
    resolucion: event.extendedProps.resolucion,
    motive: event.extendedProps.motive,
    delito: event.extendedProps.delito,
    audiencia: event.extendedProps.audiencia,
    liga: event.extendedProps.liga,
    cj: event.extendedProps.cj,
    allDay: event.allDay
  }

  console.log(event, 'event')

  const newEvent = {}
  Object.keys(event).forEach(key => {
    if (event[key] === '' || event[key] === undefined) {
      console.log('no entra')
    } else {
      newEvent[key] = event[key]
    }
  })

  await apiRequest.patch(`/events/${id}`, { ...newEvent })
  await dispatch(fetchEvents(getState().calendar.selectedCalendars))
  return event
})

export const updateFilter = createAsyncThunk('appCalendar/updateFilter', async (filter, { dispatch, getState }) => {
  if (getState().calendar.selectedCalendars.includes(filter)) {
    await dispatch(fetchEvents({calendars:getState().calendar.selectedCalendars.filter(i => i !== filter)}))
  } else {
    await dispatch(fetchEvents({calendars:[...getState().calendar.selectedCalendars, filter]}))
  }
  return filter
})

export const updateAllFilters = createAsyncThunk('appCalendar/updateAllFilters', async (value, { dispatch, getState }) => {
  if (value === true) {
    await dispatch(fetchEvents({calendars:getState().calendar.availableCalendars.map(i => i.name)}))
  } else {
    await dispatch(fetchEvents([]))
  }
  return value
})

export const updateCalendars = createAsyncThunk('appCalendar/updateCalendars', async () => {
  const response = await apiRequest.get(`/eventTypes`)
  return response.data.results
})

export const updateModalidadFilter = createAsyncThunk('appCalendar/updateModalidadFilter', async (modalidad, { dispatch, getState }) => {
  const current = getState().calendar.selectedModalidades
  const updated = current.includes(modalidad)
    ? current.filter(m => m !== modalidad)
    : [...current, modalidad]
  await dispatch(fetchEvents({ calendars: getState().calendar.selectedCalendars, modalidades: updated }))
  return updated
})

export const updateLocationFilter = createAsyncThunk('appCalendar/updateLocationFilter', async (location, { dispatch, getState }) => {
  const current = getState().calendar.selectedLocations
  const updated = current.includes(location)
    ? current.filter(l => l !== location)
    : [...current, location]
  await dispatch(fetchEvents({ calendars: getState().calendar.selectedCalendars, locations: updated }))
  return updated
})

export const removeEvent = createAsyncThunk('appCalendar/removeEvent', async id => {
  await apiRequest.delete(`/events/${id}`)
  return id
})

export const appCalendarSlice = createSlice({
  name: 'appCalendar',
  initialState: {
    events: [],
    selectedEvent: {},
    selectedCase:null,
    selectedRange:null,
    filterCase:false,
    availableCalendars:[],
    selectedCalendars: [],
    // Modalidad de Contacto filter
    selectedModalidades: [],
    availableModalidades: ['TELEFONO', 'PRESENCIAL', 'VIRTUAL'],
    // Ubicación (Sede) filter
    selectedLocations: [],
    availableLocations: ['CEEAVNL', 'DEPENDENCIA', 'EXTRAMUROS']
  },
  reducers: {
    selectEvent: (state, action) => {
      state.selectedEvent = action.payload
    },
    selectCase: (state, action) => {
      state.selectedCase = action.payload
    },
    setRange: (state, action) => {
      state.selectedRange = action.payload
    },
    setFilterCase: (state, action) => {
      state.filterCase = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchEvents.fulfilled, (state, action) => {
        state.events = action.payload
      })
      .addCase(updateCalendars.fulfilled, (state, action) => {
        state.availableCalendars = action.payload
      })
      .addCase(updateFilter.fulfilled, (state, action) => {
        if (state.selectedCalendars.includes(action.payload)) {
          state.selectedCalendars.splice(state.selectedCalendars.indexOf(action.payload), 1)
        } else {
          state.selectedCalendars.push(action.payload)
        }
      })
      .addCase(updateAllFilters.fulfilled, (state, action) => {
        const value = action.payload
        let selected = []
        if (value === true) {
          selected = state.availableCalendars.map(i => i.name)
        } else {
          selected = []
        }
        state.selectedCalendars = selected
      })
      .addCase(updateModalidadFilter.fulfilled, (state, action) => {
        state.selectedModalidades = action.payload
      })
      .addCase(updateLocationFilter.fulfilled, (state, action) => {
        state.selectedLocations = action.payload
      })
  }
})

export const { selectEvent, selectCase, setFilterCase, setRange } = appCalendarSlice.actions

export default appCalendarSlice.reducer
